/** @format */

import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchBrokerProfileBySlugService } from 'services/apiService';
import * as actionTypes from 'stateContainer/action-types';
import { push } from 'connected-react-router';

function* workerSaga({ payload }) {
  try {
    const response = yield call(fetchBrokerProfileBySlugService, payload);
    if (response.data.status == 'success') {
      yield put({
        type: actionTypes.BROKER_PROFILE_BY_SLUG_SUCCESS,
        payload: response.data.data
      });
    } else {
      throw new Error('Fetch broker profile failed');
    }
  } catch (error) {
    yield put({ type: actionTypes.BROKER_PROFILE_BY_SLUG_ERROR, error });
    yield put(push('/404'));
  }
}

export function* brokerProfileBySlugSaga() {
  yield takeLatest(actionTypes.BROKER_PROFILE_BY_SLUG_REQUESTED, workerSaga);
}
